import { SquarePen, Trash } from "lucide-react";

export const SponsorsTable = ({ sponsors, onEdit, onDelete, loading }) => {
  if (loading) {
    return <div>Loading Sponsors...</div>;
  }

  return (
    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-[#FFD4F4]">
          <th className="border px-4 py-3 text-left">Name</th>
          <th className="border px-4 py-3 text-left">Relationship</th>
          <th className="border px-4 py-3 text-left">Occupation</th>
          <th className="border px-4 py-3 text-left">Source of Income</th>
          <th className="border px-4 py-3 text-left">ITR</th>
          <th className="border px-4 py-3 text-left">Action</th>
        </tr>
      </thead>
      <tbody>
        {sponsors.length > 0 ? (
          sponsors.map((s, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="border px-4 py-3">{s.sponsorName}</td>
              <td className="border px-4 py-3">{s.relationship}</td>
              <td className="border px-4 py-3">{s.occupation}</td>
              <td className="border px-4 py-3">{s.sourceOfIncome}</td>
              <td className="border px-4 py-3">
                {s.filledItr === 1 ? "Yes" : "No"}
              </td>
              <td className="border px-4 py-3 flex gap-2">
                <button
                  onClick={() => onEdit(index)}
                  className="text-blue-600 hover:underline"
                >
                  <SquarePen />
                </button>
                <button
                  onClick={() => onDelete(index)}
                  className="text-red-600 hover:underline"
                >
                  <Trash />
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center py-4">
              No sponsors added yet.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
